import {initSwiperFlatsSlider} from '../../common/scripts/common';

const STATE_FOLDED = 'folded';
const STATE_UNFOLDED = 'unfolded';

export class StickyButton {
    constructor(element) {
        this.element = element;
        this.id = parseInt(this.element.dataset.popupId);
        this.foldButton = this.element.querySelector('.j-sticky-button-fold');
        this.foldWrapper = this.element.querySelector('.j-sticky-button-fold-filler');
    }

    _unfold() {
        this.state = STATE_UNFOLDED;
        this.element.dataset.folded = false;
        this.element.classList.remove('sticky-btn_folded');
        localStorage.setItem(this._getStateKey(), this.state);
    }

    _fold() {
        this.state = STATE_FOLDED;
        this.element.dataset.folded = true;
        this.element.classList.add('sticky-btn_folded');
        localStorage.setItem(this._getStateKey(), this.state);
    }

    _getStateKey() {
        return `promo-state-${this.id}`;
    }

    _isFolded() {
        return this.state === STATE_FOLDED;
    }

    init() {
        this.state = localStorage.getItem(this._getStateKey()) ?? STATE_UNFOLDED;
        this.setState(this.state);

        this.foldButton.addEventListener('click', (event) => {
            if (this._isFolded()) {
                return;
            }
            event.stopPropagation();
            this.setState(STATE_FOLDED);
        });
        this.foldWrapper.addEventListener('click', (event) => {
            if (!this._isFolded()) {
                return;
            }
            event.stopPropagation();
            this.setState(STATE_UNFOLDED);
        });
    }

    setState(state) {
        switch (state) {
            case STATE_FOLDED: {
                this._fold();
                break;
            }
            case STATE_UNFOLDED: {
                this._unfold();
                break;
            }
            default: break;
        }
    }
}

class CountdownTimer {
    constructor(container, cbChange, cbComplete) {
        this._cbChange = cbChange;
        this._cbComplete = cbComplete;
        this._timerId = null;
        this._out = {
            days        : '',
            hours       : '',
            minutes     : '',
            daysTitle   : '',
            hoursTitle  : '',
            minutesTitle: '',
            secondsTitle: ''
        };

        this._dayContainer = container.querySelector('.timer__value-item_day');
        this._dayValue = this._dayContainer.querySelector('.timer__value');
        this._dayName = this._dayContainer.querySelector('.timer__name-value');

        this._hourContainer = container.querySelector('.timer__value-item_hour');
        this._hourValue = this._hourContainer.querySelector('.timer__value');
        this._hourName = this._hourContainer.querySelector('.timer__name-value');

        this._minuteContainer = container.querySelector('.timer__value-item_minute');
        this._minuteValue = this._minuteContainer.querySelector('.timer__value');
        this._minuteName = this._minuteContainer.querySelector('.timer__name-value');

        this._receivedDeadlineValue = container.querySelector('.timer__wrapper').dataset.deadline;
        this._deadline = new Date(this._receivedDeadlineValue);
        this._start();
    }

    // Склонения числительных
    static declensionNum(num, words) {
        return words[num % 100 > 4 && num % 100 < 20 ? 2 : [2, 0, 1, 1, 1, 2][num % 10 < 5 ? num % 10 : 5]];
    }

    _start() {
        this._calc();
        this._timerId = setInterval(this._calc.bind(this), 1000);
    }

    // Вычисление оставшегося ко-ва дней, часов, минут и секунд
    _calc() {
        const diff = this._deadline - new Date();
        const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
        const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
        const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;

        this._out.days = days;
        this._out.hours = hours;
        this._out.minutes = minutes;
        this._out.daysTitle = CountdownTimer.declensionNum(days, ['день', 'дня', 'дней']);
        this._out.hoursTitle = CountdownTimer.declensionNum(hours, ['час', 'часа', 'часов']);
        this._out.minutesTitle = CountdownTimer.declensionNum(minutes, ['минута', 'минуты', 'минут']);

        if (this._cbChange) {
            this._cbChange(this);
        }

        if (diff <= 0) {
            clearInterval(this._timerId);
            if (this._cbComplete) {
                this._cbComplete();
            }
        }
    }

    updateDisplaying() {
        this._dayValue.textContent = this._out.days;
        this._hourValue.textContent = this._out.hours;
        this._minuteValue.textContent = this._out.minutes;
        this._dayName.textContent = this._out.daysTitle;
        this._hourName.textContent = this._out.hoursTitle;
        this._minuteName.textContent = this._out.minutesTitle;
    }
}


// Создание и запуск таймера
const startCountdownTimer = function(container, onChange, onComplete) {
    return new CountdownTimer(container, onChange, onComplete);
};

// Таймер в кнопке
const timerContainer = document.querySelector('.sticky-btn__timer-inner > .sticky-btn__timer');

if (timerContainer) {
    startCountdownTimer(timerContainer, (timer) => {
        return timer.updateDisplaying();
    }, () => {
        const resultEl = document.querySelector('.timer-1 .timer__result');

        if (resultEl) {
            resultEl.textContent = 'Таймер завершился!';
        }
    });
}

const fillerTimerContainer = document.querySelector('.j-sticky-button-fold-filler > .sticky-btn__timer');

if (fillerTimerContainer) {
    startCountdownTimer(fillerTimerContainer, (timer) => {
        return timer.updateDisplaying();
    }, () => {
        const resultEl = document.querySelector('.timer-1 .timer__result');

        if (resultEl) {
            resultEl.textContent = 'Таймер завершился!';
        }
    });
}

const timerContainerPopup = document.querySelector('.timer-popup__timer');

if (timerContainerPopup) {
    startCountdownTimer(timerContainerPopup, (timer) => {
        return timer.updateDisplaying();
    }, () => {
        const resultEl = document.querySelector('.timer-1 .timer__result');

        if (resultEl) {
            resultEl.textContent = 'Таймер завершился!';
        }
    });
}

const popupBtn = document.querySelector('.sticky-btn');

if (popupBtn) {
    popupBtn.addEventListener('click', () => {
        setTimeout(() => {
            const sliderFlats = Array.from(document.querySelectorAll('.j-flats-slider'));

            sliderFlats.forEach((wrapper) => {
                initSwiperFlatsSlider({wrapper});
            });
        }, 1000);
    });

    if (window.innerWidth < 669) {
        const calcRightMargin = (popupBtn.offsetWidth / 2) - 21;

        popupBtn.style.right = `-${calcRightMargin}px`;
    }
}


